import { render, staticRenderFns } from "./WarningsAndFlagsWidget.vue?vue&type=template&id=6493d586&"
import script from "./WarningsAndFlagsWidget.vue?vue&type=script&lang=js&"
export * from "./WarningsAndFlagsWidget.vue?vue&type=script&lang=js&"
import style0 from "./WarningsAndFlagsWidget.vue?vue&type=style&index=0&id=6493d586&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports